import React from "react";
import { FaRegHandPointer } from "react-icons/fa";

const RetailBreakupKPI = ({
  image,
  totalValue,
  newInvoice,
  cancelledInvoice,
  directBilling,
  colorClass,
  imageSize = "w-9",
  padding,
  onClick,
  handPosition = "left-[-8%] -translate-x-1/2 top-[80%] -translate-y-1/2",
}) => {
  return (
    <div
      onClick={onClick}
      className={`grid grid-cols-[auto_1fr] ${padding} gap-1 text-white rounded-lg ${colorClass} cursor-pointer transition duration-300 ease-in-out transform hover:scale-105`}
    >
      {/* LEFT ICON */}
      <div className="flex items-start">
        <img src={image} alt="Retail KPI" className={imageSize} />
      </div>

      <div className="relative w-full">
        {/* HAND ICON */}
        {onClick && (
          <div
            className={`absolute flex justify-center items-center ${handPosition}`}
          >
            <span className="relative p-1 text-white bg-[#e03f3f] rounded-full">
              <FaRegHandPointer />
              <span className="absolute inset-0 rounded-full bg-sky-400 opacity-75 blur-md animate-ping"></span>
            </span>
          </div>
        )}
        {/* HEADERS ROW */}
        <div className="flex justify-between font-semibold text-sm gap-1 items-center">
          <div className="flex flex-col rounded-md bg-[rgba(0,0,0,0.22)] text-center">
            <span className="px-2 text-white">Total Retail</span>
            <span className="px-2 text-white">{totalValue}</span>
          </div>
          =
          <div className="flex flex-col rounded-md bg-[rgba(0,0,0,0.22)] text-center">
            <span className="px-2 text-white">New Invoice</span>
            <span className="px-2 text-white">{newInvoice}</span>
          </div>
          -
          <div className="flex flex-col rounded-md bg-[rgba(0,0,0,0.22)] text-center">
            <span className="px-2 text-white">Cancel Invoice</span>
            <span className="px-2 text-white">{cancelledInvoice}</span>
          </div>
          +
          <div className="flex flex-col rounded-md bg-[rgba(0,0,0,0.22)] text-center">
            <span className="px-2 text-white">Direct Billing</span>
            <span className="px-2 text-white">{directBilling}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetailBreakupKPI;
